import { TPagingResponse } from './api';

export enum PostPatientParams {
  Name = 'name',
  PhoneNum = 'phoneNum',
  BirthDate = 'birthDate',
  Sex = 'sex',
  Relation = 'relation',
  Occupation = 'occupation',
  Complaint = 'complaint',
}

export type TPatientDupCheckPhoneNumParams = {
  phoneNum: string;
};

export type TPatientListParams = {
  page: number;
  size: number;
  searchWord?: string;
  startDate?: string;
  endDate?: string;
  sex?: string[];
  sortBy?: PatientInfoSortBy;
  isAsc?: boolean;
};

export type TPatientTableInfo = {
  patientId: number;
  name: string;
  birthAndAge: string;
  sex: string;
  phoneNum: string;
  occupation?: string;
  relation?: string;
  createdAt: string;
};

export type TPatientList = {
  patientList: TPatientTableInfo[];
};

export type TPatientListResponse = TPagingResponse<TPatientList>;

export type TRegisteredChartName = {
  registeredChartName: string;
};

export type TChartListDropdown = {
  courseId: number;
  courseName: string;
  registeredChartNameList: TRegisteredChartName[];
};

export type TPatientSimpleInfo = {
  patientId: number;
  name: string;
  birthAndSex: string;
};

export type TPatientSimpleList = {
  patientSimpleList: TPatientSimpleInfo[];
};

export type TRegisterPatientInfoParams = {
  name: string;
  phoneNum: string;
  birthDate: string;
  sex: string;
  relation?: string;
  occupation?: string;
  complaint: string;
};

export type TPatientCardInfo = {
  name: string;
  ageAndSex: string;
  agreeOrNot: string;
  complaint: string;
};

export type TPatientInfoResponse = {
  name: string;
  phoneNum: string;
  birthDate: string;
  sex: string;
  relation?: string;
  occupation?: string;
  agreeDate?: string;
  complaint: string;
};

export enum PatientInfoSortBy {
  Name = 'name',
  BirthAndAge = 'birthAndAge',
  Sex = 'sex',
  Occupation = 'occupation',
  Relation = 'relation',
  CreatedAt = 'createdAt',
}
